<script lang="ts">
    import HeroContainerWithImage from "./HeroContainerWithImage.svelte";
    import HeroSplitWithImage from "./HeroSplitWithImage.svelte";
    import HeroSplitWithScreenshot from "./HeroSplitWithScreenshot.svelte";
    import HeroWithImageDown from "./HeroWithImageDown.svelte";

    export let section;
    export let index: number;
</script>

{#if section.type === 'simple-split-with-background'}
    <HeroSplitWithImage {section} {index} />
{:else if section.type === 'simple-split-without-background'}
    <HeroSplitWithScreenshot {section} {index} />
{:else if section.type === 'split-container-with-background'}
    <HeroContainerWithImage {section} {index} />
{:else if section.type === 'split-with-image-down'}
    <HeroWithImageDown {section} {index} />
{/if}
